/* global slideUp, slideDown, attachEvent */
// **************************************************
// Card Content Toggle
// **************************************************

attachEvent('.hackaton-card__footer .btn', 'click', (ev) => {
  const card = ev.target.closest('.hackaton-card');
  if (card) {
    const cardContent = card.querySelector('.hackaton-card__content');

    if (card.classList.contains('is-open')) {
      card.classList.remove('is-open');
      slideUp(cardContent, 300);
    } else {
      card.classList.add('is-open');
      slideDown(cardContent, 300);
    }
  }

  ev.preventDefault();
});
